import React, { useState } from 'react';
import Chatbot from './Chatbot';

const Help = () => {
    const [isChatOpen, setIsChatOpen] = useState(false);

    const toggleChat = () => {
        setIsChatOpen(!isChatOpen);
    };

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light position-relative">
            {isChatOpen && (
                <div className="card shadow-lg p-4" style={{ maxWidth: '400px', height: '600px', zIndex: 10, position: 'fixed', bottom: '100px', right: '30px' }}>
                    <h1 className="text-center mb-4">
                        <span className="text-primary">Ayuda</span>
                        <span className="text-info">On Line</span>
                    </h1>
                    <Chatbot />
                </div>
            )}

            <button
                onClick={toggleChat}
                className="btn btn-primary rounded-circle shadow-lg position-fixed"
                style={{ bottom: '30px', right: '30px', width: '60px', height: '60px', zIndex: 20 }}
                aria-label={isChatOpen ? "Cerrar Chatbot" : "Abrir Chatbot"}
            >
                {isChatOpen ? (
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" style={{ width: '30px', height: '30px' }}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '30px', height: '30px' }}>
                        <path d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10zm0-16.5a2.5 2.5 0 0 1 2.5 2.5v2.5a2.5 2.5 0 0 1-5 0V7.5A2.5 2.5 0 0 1 12 5.5zM12 17.5a1.5 1.5 0 0 1-1.5-1.5h-1a2.5 2.5 0 0 0 2.5 2.5h1a2.5 2.5 0 0 0 2.5-2.5h-1A1.5 1.5 0 0 1 12 17.5zM16.5 12h-9" />
                    </svg>
                )}
            </button>
        </div>
    );
};

export default Help;
